import { render } from "./LabLibrary.vue?vue&type=template&id=72e55c96&scoped=true"
import script from "./LabLibrary.vue?vue&type=script&lang=js"
export * from "./LabLibrary.vue?vue&type=script&lang=js"

import "./LabLibrary.vue?vue&type=style&index=0&id=72e55c96&scoped=true&lang=css"

import exportComponent from "D:\\htdocs\\cosmocoslab_live\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e55c96"]])

export default __exports__